import { ref, readonly } from 'vue'
import incomingCallUrl from '@/assets/sound/incomingCall.mp3?url'
import outgoingCallUrl from '@/assets/sound/outgoingCall.mp3?url'

export function createRingtone(isOutCall: boolean = false) {
  const isEnabled = ref(false)
  const soundUrl = isOutCall ? outgoingCallUrl : incomingCallUrl
  let audio: HTMLAudioElement | null = null

  function enableSound(): void {
    if (audio) {
      audio.play()
      isEnabled.value = true
      return
    }

    audio = new Audio(soundUrl)
    audio.loop = true
    audio.load()

    audio.play()
      .then(() => {
        isEnabled.value = true
      })
      .catch(() => {
        isEnabled.value = false
        audio = null
      })
  }

  function stopRingtone(): void {
    if (audio) {
      audio.pause()
      audio.currentTime = 0
    }
  }

  return {
    isEnabled: readonly(isEnabled),
    enableSound,
    stopRingtone,
  }
}

export const ringtone = createRingtone()
export const ringtoneOutCall = createRingtone(true)